<template>
  <i-drawer
    :visible="isShowable"
    class="credit-agent-modal"
    title="AI Underwriting Assistant"
    subtitle="Effortlessly Navigate Complex Data with our AI Underwriting Assistant "
    @hide-drawer="closeDrawer"
  >
    <div>
      <div class="credit-agent-modal__responses">
        <div
          class="credit-agent-modal__explanation i-p-10 i-mb-10 i-text-neutral-120 i-radius-md"
        >
          <h5 class="i-text-button-3">
            How to use the AI Underwriting Assistant:
          </h5>
          <p
            v-for="(point, index) in agentHelpPoints"
            :key="index"
            class="i-text-body-3 i-mb-4 d-flex"
          >
            <i-icon
              symbol="small-solid-info"
              class="i-mt-1 i-mr-4 i-text-primary-90 flex-shrink-0"
              :size="12"
            />
            <span>{{ point }}</span>
          </p>
        </div>
        <div
          v-for="(response, index) in responses"
          :id="`response${index}`"
          :key="index"
          :ref="`response${index}`"
          class="credit-agent-modal__response d-flex flex-column justify-content-between i-mb-8"
        >
          <div
            class="credit-agent-modal__response-question i-mb-4 d-flex justify-content-end"
          >
            <div
              class="i-text-body-2 i-text-neutral-default justify-content-end i-radius-tr-xs i-radius-tl-2xl i-radius-bl-2xl i-radius-br-2xl i-bg-primary-90 i-p-lg"
            >
              {{ response.question }}
            </div>
          </div>

          <div class="credit-agent-modal__response-answer i-mt-4 d-flex">
            <div
              class="i-text-body-2 i-text-neutral-120 i-radius-tr-2xl i-radius-tl-xs i-radius-bl-2xl i-radius-br-2xl i-bg-primary-30 i-p-lg"
              v-html="sanitiseHtmlAgainstXss(response.answer)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="w-100">
        <div class="d-flex w-100 i-form-input-group">
          <i-text-input
            :id="`agent-label-${_uid}`"
            class="w-100"
            placeholder="Example: List all retail transactions"
            :value="question"
            @on-input-enter="askQuestion"
            @input="
              (value) => {
                question = value;
              }
            "
          ></i-text-input>

          <i-button
            class="input-action credit-agent-modal__send-button i-radius-md i-ml-4"
            title="Ask question"
            left-icon="small-solid-send"
            type="primary"
            :type="iButtonTypes.PRIMARY"
            :button-style="iButtonStyles.SOLID_DARK"
            :size="iButtonSizes.LARGE"
            size="lg"
            :loading="isLoading"
            @button-click="askQuestion"
          >
          </i-button>
        </div>
      </div>
    </template>
  </i-drawer>
</template>

<script>
import { mapActions } from 'vuex';
import {
  iButton,
  iButtonTypes,
  iButtonStyles,
  iButtonSizes,
  iDrawer,
  iIcon,
  iTextInput,
} from '@inscribe/signal';
import { marked } from 'marked';
export default {
  components: {
    iButton,
    iDrawer,
    iIcon,
    iTextInput,
  },
  props: {
    isShowable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      question: '',
      responses: [],
      isLoading: false,
      iButtonTypes,
      iButtonStyles,
      iButtonSizes,
      agentHelpPoints: [
        'Ask questions in a specific and detailed way.',
        "Provide feedback to the assistant's responses so that they can be improved over time.",
      ],
    };
  },
  methods: {
    ...mapActions(['sendAgentQuery']),
    closeDrawer() {
      this.$emit('hide-faq-modal');
    },
    scrollToResponse(response) {
      const responseRef = this.$refs[response][0];
      responseRef.scrollIntoView({
        behavior: 'smooth',
      });
    },
    async askQuestion() {
      if (!this.question) return;
      try {
        this.isLoading = true;
        const response = await this.sendAgentQuery({
          customerId: this.$route.params.customer_id,
          query: this.question,
        });
        this.responses.push({
          question: this.question,
          answer: response.data.data,
        });
        this.question = '';
        this.isLoading = false;
        this.$nextTick(() => {
          this.scrollToResponse(`response${this.responses.length - 1}`);
        });
      } catch (error) {
        this.responses.push({
          question: this.question,
          answer: 'There was a problem. Please try again.',
        });
        this.question = '';
        this.isLoading = false;
      }
    },
    sanitiseHtmlAgainstXss(htmlApiResponse) {
      return marked(htmlApiResponse);
    },
  },
};
</script>
<style lang="scss" scoped>
.credit-agent-modal {
  background: inherit;
  &__header {
    width: 85%;
  }
  &__explanation {
    background: $light-primary-20;
    border: 1px solid $light-primary-80;
  }
  &__response-question,
  &__response-answer {
    div {
      max-width: 80%;
      :deep(p:not(:last-child)) {
        margin-bottom: map.get($increments, 4) !important;
      }
    }
  }
}
</style>
